// Copyright (c) 2017 Deere & Company

import './index.scss';
import React, {PropTypes} from 'react';
import ClaimVsrMessage from '@deere/cps-it.warranty-model-factory/lib/claim-vsr-message';
import Popover from '../../../../shared/components/popover/popover';
import VsrMessages from '../vsr-messages';
import {translate} from '../../../../shared/services/translation-service';

const getIcon = (count, component) => count ? component : null;

const VsrMessagePopover = props => {

    const popoverTarget = (
        <div className='vsr-icons'>
            {getIcon(props.errorMessages.length, <span className='claim-error-icon'/>)}
            {getIcon(props.warningMessages.length, <span className='claim-warning-icon'/>)}
            {getIcon(props.infoMessages.length, <span className='claim-info-icon'/>)}
        </div>
    );

    const popoverContent = (
        <div className='vsr-message-popover'>
            <VsrMessages
                className='vsr-error-message'
                isEditable={props.isEditable}
                title={translate('ERROR_MESSAGES')}
                vsrMessages={props.errorMessages}
            />
            <VsrMessages
                className='vsr-warning-message'
                isEditable={props.isEditable}
                title={translate('WARNING_MESSAGES')}
                vsrMessages={props.warningMessages}
            />
            <VsrMessages
                className='vsr-info-message'
                isEditable={props.isEditable}
                title={translate('INFO_MESSAGES')}
                vsrMessages={props.infoMessages}
            />
        </div>
    );

    return (
        <Popover
            content={popoverContent}
            target={popoverTarget}
        />
    );

};

VsrMessagePopover.displayName = 'VsrMessagePopover';
VsrMessagePopover.propTypes = {
    errorMessages: PropTypes.arrayOf(PropTypes.instanceOf(ClaimVsrMessage)).isRequired,
    infoMessages: PropTypes.arrayOf(PropTypes.instanceOf(ClaimVsrMessage)).isRequired,
    isEditable: PropTypes.bool.isRequired,
    warningMessages: PropTypes.arrayOf(PropTypes.instanceOf(ClaimVsrMessage)).isRequired
};

export default VsrMessagePopover;



// WEBPACK FOOTER //
// ./src/claim/shared/components/vsr-popover/index.js